import React, { useState } from 'react';
import styles from './W_CapsuleContentEmptyState.module.css';
import A_ImageRocks from '@/assets/images/A_ImageRocks.png';
import A_ContentEmpty from '@/assets/images/A_ContentEmpty.png';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';
import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import S_AddCapsuleContentPopup from '@/components/S_Super-Organisms/S_AddCapsuleContentPopup/S_AddCapsuleContentPopup';

export default function W_CapsuleContentEmptyState({
  onSaveContent,
}: {
  onSaveContent: (contentItem: any) => void;
}) {
  const [isAddCapsuleContentPopupOpen, setIsAddCapsuleContentPopupOpen] =
    useState(false);
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);

  return (
    <div className={styles.wrapper}>
      <div className={styles.image_content_empty_wrapper}>
        <img src={A_ContentEmpty} alt='Content Empty' />
      </div>
      <div className={styles.image_rocks_wrapper}>
        <img src={A_ImageRocks} alt='Rocks' />
      </div>

      <div className={styles.button_wrapper}>
        <p className={cn(styles.text, 'text-p-6')}>
          {t('capsuleCreate.contentEmpty')}
        </p>
        <A_CircleButton
          icon={<Q_Icon.PlusIcon width={24} height={24} fill='currentColor' />}
          variant='secondary'
          onClick={() => {
            setIsAddCapsuleContentPopupOpen(true);
          }}
        />
      </div>
      {isAddCapsuleContentPopupOpen && (
        <S_AddCapsuleContentPopup
          setIsAddCapsuleContentPopupOpen={setIsAddCapsuleContentPopupOpen}
          onSaveContent={onSaveContent}
        />
      )}
    </div>
  );
}
